import { render, staticRenderFns } from "./QuotationByLocationTable.vue?vue&type=template&id=1836c22c&scoped=true&"
import script from "./QuotationByLocationTable.vue?vue&type=script&lang=js&"
export * from "./QuotationByLocationTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotationByLocationTable.vue?vue&type=style&index=0&id=1836c22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836c22c",
  null
  
)

export default component.exports